import { createPortal } from "react-dom";
import { ReactNode } from "react";
import { PageTitleSection } from "../../../../common/components/PageTitleSection/PageTitleSection";
import { TimeStamp } from "../../../../common/components/TimeStamp/TimeStamp";
import { ActionReportTitleSelector } from "../ActionReportTitleSelector/ActionReportTitleSelector";
import useWindowSize from "../../../../common/hooks/useWindowSize";
import breakpoints from "../../../../common/scss/breakpoints.module.scss";
import "./ActionReportTitlePortal.scss";

interface ActionReportTitlePortalProps {
  title: string;
  infoButton?: ReactNode;
  className?: string;
  showTimeStamp?: boolean;
}

/**
 * Component that handles rendering ActionReportTitleSelector in the correct location
 * - Desktop (>1024px): Renders in TopNavigationBar portal
 * - Mobile: Renders in PageTitleSection
 */
export const ActionReportTitlePortal = ({
  title,
  infoButton,
  className = "",
  showTimeStamp,
}: ActionReportTitlePortalProps) => {
  const { width } = useWindowSize();
  const isDesktop = width ? width > Number(breakpoints.desktop) : false;

  const portalTarget = document.getElementById("title-portal");
  const usePortal = isDesktop && portalTarget !== null;

  const titleHeader = (
    <div className={`ActionReportTitlePortal ${className}`}>
      <h1 className="sr-only">{title}</h1>
      <ActionReportTitleSelector />
      {infoButton}
      {showTimeStamp && <TimeStamp dateFormat="bigEndian" />}
    </div>
  );

  if (usePortal) {
    return createPortal(titleHeader, portalTarget);
  }

  return (
    <PageTitleSection
      title={title}
      actionReportSelector={<ActionReportTitleSelector />}
      infoButton={infoButton}
      hideTimeStamp={showTimeStamp === false}
    />
  );
};
